// extracted by mini-css-extract-plugin
export default {"cls1":"Truncate-cls1_AWM","cls2":"Truncate-cls2_lTS Truncate-cls1_AWM"};